import { render, staticRenderFns } from "./createStore.vue?vue&type=template&id=0c540a32&scoped=true&"
import script from "./createStore.vue?vue&type=script&lang=js&"
export * from "./createStore.vue?vue&type=script&lang=js&"
import style0 from "./createStore.vue?vue&type=style&index=0&id=0c540a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c540a32",
  null
  
)

export default component.exports